import { useEffect, useState } from 'react';
import { api } from '../api';


export default function Quotes() {
  const [loading, setLoading] = useState(true);
  const [quote, setQuote] = useState('');

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const res = await api('/me/daily-quote');
        if (alive && res?.ok) setQuote(res.quote?.text || '');
      } catch (_) {}
      if (alive) setLoading(false);
    })();
    return () => { alive = false; };
  }, []);

  return (
    <div className="personal-component has-glow glow-center glow-sm">
      <div className="quote-box ">
        {loading ? (
          <span className="muted">Loading…</span>
        ) : quote ? (
          <blockquote className="quote-text">“{quote}”</blockquote>
        ) : (
          <span className="muted">No quote available.</span>
        )}
      </div>
    </div>
  );
}